"use strict";
/**
 * 对话框
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
require("./index.less");
function Modal(props) {
    var thisbody = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (thisbody.current) {
            var thisdom = thisbody.current;
            var width = thisdom.clientWidth;
            var height = thisdom.clientHeight;
            thisdom.style.margin = "".concat(-(height / 2), "px 0 0 ").concat(-(width / 2), "px");
        }
    }, []);
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "modal" },
        react_1.default.createElement("div", { className: "modal_shadow" }),
        react_1.default.createElement("div", { className: "modal_body", ref: thisbody },
            react_1.default.createElement("div", { className: "modal_t" }, props.title),
            props.onClose &&
                react_1.default.createElement("div", { className: "modal_close", onClick: function () { props.onClose(); } }),
            react_1.default.createElement("div", { className: "modal_b" }, props.children),
            props.onComfirm &&
                react_1.default.createElement("div", { className: "btns" },
                    react_1.default.createElement("a", { href: "#", className: "confirmbtn", onClick: function (e) { e.preventDefault(); props.onComfirm(); } }, "\u786E\u5B9A")))), document.body);
}
exports.Modal = Modal;
